import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLeftToLine } from '@fortawesome/pro-solid-svg-icons';
import { TiptapButton } from '../TiptapButton';
import { useEditorContext, useEditorSelector } from '../../editor_context';
import { _js } from '@ifixit/utils/localize';

export const GridRemoveColumnButton = () => {
   const { editor } = useEditorContext();
   const state = useEditorSelector(editor => ({
      isDisabled: !editor.can().decreaseColumns(),
   }));

   if (!state) {
      return null;
   }

   return (
      <TiptapButton
         onClick={() => editor.chain().focus().decreaseColumns().run()}
         isDisabled={state.isDisabled}
         icon={<FontAwesomeIcon icon={faLeftToLine} />}
         title={_js('Remove column')}
      />
   );
};
